export default {
  route: {
    dashboard: '首页',
    introduction: '简述',
    deviceManage: '设备管理',
    guide: '引导页',
    permission: '权限测试页',
    pagePermission: '页面权限',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    componentIndex: '介绍',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合实例',
    nested: '路由嵌套',
    menu1: '菜单1',
    'menu1-1': '菜单1-1',
    'menu1-2': '菜单1-2',
    'menu1-2-1': '菜单1-2-1',
    'menu1-2-2': '菜单1-2-2',
    'menu1-3': '菜单1-3',
    menu2: '菜单2',
    Table: 'Table',
    dynamicTable: '动态Table',
    dragTable: '拖拽Table',
    inlineEditTable: 'Table内编辑',
    complexTable: '综合Table',
    treeTable: '树形表格',
    customTreeTable: '自定义树表',
    tab: 'Tab',
    form: '表单',
    createArticle: '创建文章',
    editArticle: '编辑文章',
    articleList: '文章列表',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    exportZip: 'Export Zip',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    externalLink: '外链',
    normalDevice: '设备列表',
    groupDevice: '分组管理',
    baseModule: '基础模块',
    statusManage: '状态管理',
    applicationManage: '应用管理',
    roleManage: '角色管理',
    fieldList: '场地列表',
    personalCenter: '个人中心',
    staffManage: '人员管理',
    accountManage: '财务管理',
    refundRecord: '退款记录',
    cashaudit: '提现审核',
    accountFlow: '账户流水',
    userManages: '账户管理',
    userAccountFlow: '账户流水',
    transferAccount: '转账记录',
    advertiseManage: '广告管理',
    courierAudit: '快递员审核',
    userManage: '用户管理',
    expressCompany: '快递公司',
    orderManage: '订单管理',
    reportManage: '报表管理',
    agentIncomeTotal: '代理商收入统计',
    localIncomeTotal: '场地方收入统计',
    deviceList: '设备管理',
    fieldManages: '场地管理',
    binDingAgents: '绑定代理商',
    withdrawalAudit: '提现审核',
    userWithdrawalAudit: '用户提现审核',
    deductRem: '余额发放扣除',
    withdrawRecord: '提现记录',
    setCosts: '充值费用设置',
    report: '场地收入统计',
    advList: '广告列表',
    putPlan: '投放计划',
    operation: '运维管理',
    versionUpdate: '版本更新',
    config: '提现配置',
    feedback: '投诉&建议',
    shopList: '商户管理',
    shopManages: '商户管理'
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    screenfull: '全屏',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    roles: '你的权限',
    switchRoles: '切换权限'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    title: '标题',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    addTime: '添加时间',
    export: '导出',
    id: '序号',
    number: '编号',
    name: '名称',
    module: '模块',
    moduleName: '模块名称',
    entityName: '实体名称',
    remarks: '备注',
    date: '时间',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    imei: '设备标识号',
    address: '地址',
    size: '规格',
    version: '版本类型',
    saveType: '存储类型',
    owner: '所属用户',
    versionName: '版本名称',
    deviceName: '设备名称',
    lastConnTime: '最后连接时间',
    lastModifyTime: '最后修改时间',
    cellNum: '箱子数目',
    userCount: '使用次数',
    totalIncome: '总收入(元)',
    expireTime: '到期时间',
    'Data_statistics': '数据统计',
    submit: '提交',
    detail: '详情',
    renew: '续费',
    useStatus: '使用情况',
    boxNum: '箱号',
    Userphone: '使用者电话',
    startTime: '开始时间',
    endTime: '结束时间',
    autoEndTime: '自动结束时间',
    lng: '经度',
    lat: '纬度',
    sort: '排序',
    route: '路由',
    permission: '权限',
    btnPermission: '按钮权限',
    templateName: '模板名称',
    templateIntroduce: '模板简介',
    lockNum: '锁号',
    lockIndex: '锁位号',
    advertiseName: '广告名称',
    advertiseIntro: '广告简介',
    videoUrl: '视频地址',
    picUrl: '图片地址',
    belongsUser: '所属用户',
    adverDetail: '广告详情',
    groupName: '分组名称',
    groupIntro: '分组简介',
    deviceManage: '设备管理',
    adsManage: '广告管理',
    deviceTotal: '设备总数',
    adsTotal: '广告总数',
    allotAds: '分配广告',
    allotDevice: '分配设备',
    unbind: '解绑',
    preview: '预览',
    bind: '绑定',
    unBind: '解绑',
    loginNo: '登录账号',
    userName: '用户名',
    sex: '性别',
    role: '角色',
    password: '密码',
    telPhone: '手机号',
    email: '邮箱',
    birthDay: '出生日期',
    idCard: '身份证号',
    realName: '真实姓名',
    avatar: '头像',
    resetPwd: '重置密码',
    changePwd: '修改密码',
    renewTime: '时长',
    expense: '费用',
    payway: '支付方式',
    payQRcode: '支付二维码',
    operatUser: '运营人员',
    importBoxSizeTemp: '导入模板',
    orderNo: '订单号',
    adds: '批量添加设备',
    addBox: '添加箱子',
    addBoxs: '批量添加箱子',
    revenueType: '收益类型',
    companyName: '快递公司名称',
    companyNamesma: '快递公司简称',
    companyAddress: '快递公司地址',
    boxList: '箱子列表',
    fieldName: '场地名称',
    fieldAddress: '场地地址',
    MonthlyFee: '包月费用',
    MonthlyDiscount: '包月折扣',
    UpdateTime: '修改时间',
    qrystaff: '查询员工',
    fieldKey: '场地关键字',
    DetailAdress: '详细地址',
    back: '返回',
    qrymember: '查询会员',
    accountId: '账户ID',
    currency: '币种',
    memo: '备注',
    rmb: '人民币',
    addUser: '添加用户',
    boxNo: '箱号',
    OrderType: '订单类型',
    PayMoney: '付款金额',
    OrderNo: '订单编号',
    OrderState: '订单状态',
    PayType: '支付方式',
    refund: '退款',
    TotalMoney: '总金额',
    Identity: '设备唯一标识号',
    lineStatus: '在线状态',
    BoxNo: '箱号编号',
    boxDId: '归属柜子',
    boxLockId: '锁板地址',
    boxLockNum: '锁号地址',
    boxTypeNo: '箱子规格',
    boxStartTime: '开始存放时间',
    boxUseTotalCount: '总使用次数',
    boxTotalIncome: '总收入(元)',
    boxTelPhone: '当前存放手机号',
    boxStatusNo: '箱子状态',
    bindField: '绑定场地',
    bindAgent: '绑定代理商',
    devicedetail: '设备详情',
    useddetail: '使用详情',
    clear: '清理',
    field: '所在场地',
    change: '选择',
    destoonFinanceCash: '申请提现',
    bindStaff: '添加员工',
    open: '打开',
    maxMemberCount: '员工柜子最大数量',
    memberCount: '员工柜子数量',
    memberBox: '员工柜子',
    downloadQRcode: '下载二维码',
    isDepositTel: '是否支持手机',
    retCoinMoney: '退款费用(元)',
    prohibit: '禁用',
    use: '启用'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  }
}
